import AiAskBarComposerShell from './AiAskBarComposerShell'
import AiAskBarContextRow from './AiAskBarContextRow'
import AiAskBarHomeInputPanel from './AiAskBarHomeInputPanel'

/**
 * The composer, ringed by its hairline shell on the landing screen only.
 * In a thread (and in build mode) the panel keeps its standalone look.
 */
export default function AiAskBarHomeComposerSection({
  isLanding,
  showContextRow = false,
  showShell = true,
  onOpenConnections,
  ...panelProps
}) {
  const panel = <AiAskBarHomeInputPanel {...panelProps} landing={isLanding} />
  if (!isLanding || !showShell) return panel

  return (
    <AiAskBarComposerShell>
      {panel}
    </AiAskBarComposerShell>
  )
}
